import { defineStore } from 'pinia';
import spacesApiService from '@/services/spaces.api.service';
import { CwxBackend } from '@/types/cwxBackend';

export const useSpaceStore = defineStore('space', {
  state: () => ({
    spaceDetails: {} as CwxBackend.ISpaceDetailsDto,
    spaceSettings: {} as CwxBackend.ISpaceSettingsDto,
  }),
  actions: {
    async fetchSpaceDetails(spaceId: number) {
      this.spaceDetails = await spacesApiService.getSpaceDetails(spaceId);
    },
    async fetchSpaceSettings(spaceId: number) {
      this.spaceSettings = await spacesApiService.getSpaceSettings(spaceId);
    },
  },
});
